import { FC } from 'react';
import clsx from 'clsx/lite';
import styles from './LoaderCell.module.css';

const LoaderCell: FC<{ rightAligned?: boolean; noTranslate?: boolean }> = ({
  rightAligned,
  noTranslate,
}) => (
  <div
    className={clsx(
      styles.wrapper,
      rightAligned && styles.rightAligned,
      noTranslate && styles.noTranslate
    )}
  >
    <div className={styles.background} />
  </div>
);

export default LoaderCell;
